<template>
  <div>
    <BasicData :form-name="formName" :show-title="showBasicDataTitle" />
    <AdditionalData :form-name="formName" />
  </div>
</template>

<script>
import formGtm from '@/mixins/formGtm';
import BasicData from '@/components/Molecules/AccountSettings/BasicData';
import AdditionalData from '@/components/Molecules/AccountSettings/AdditionalData';

export default {
  name: 'BasicDataMobile',
  components: { AdditionalData, BasicData },
  mixins: [formGtm],
  props: {
    showBasicDataTitle: {
      type: Boolean,
      default: true
    }
  }
};
</script>
